<div class="mct-flex mct-row mct-justify-between mct-items-start"  >
  <h4>{{ 'profiles.view.revenue.label' | translate | titlecase }}</h4>
  <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-27"   >
    <a [routerLink]="'/revenue/invoice/new'" [queryParams]="{ profileId: profileId }">{{
      'profiles.view.revenue.create-invoice' | translate | titlecase
    }}</a>
    <a [routerLink]="['/profile', profileId, 'transactions']">{{ 'profiles.view.revenue.view-transactions' | translate | titlecase }}</a>
  </div>
</div>
<div class="mct-flex mct-row" >
  <div   class="revenue-left mct-flex mct-col mct-basis-74">
    <div class="mct-flex mct-row" >
      <div class="chart mct-hide-lt-sm" >
        <p-chart #invoiceChart type="pie" [data]="chartData" [options]="chartOptions" [height]="136" [width]="136"></p-chart>
      </div>
      <div class="invoice-history">
        <div class="total-invoiced">
          <h4>{{ totalInvoiced | currency }}</h4>
          <div class="card-field-label">{{ 'profiles.view.revenue.total-invoiced' | translate }}</div>
        </div>
        <div class="total-invoiced">
          <div class="chart-legend-colorbox" [ngStyle]="{ 'background-color': duesColor }"></div>
          <div class="chart-legend-value">{{ chartData.datasets[0].data[0] | currency }}</div>
          <div class="card-field-label">{{ 'profiles.view.revenue.dues' | translate }}</div>
        </div>
        <div class="total-invoiced">
          <div class="chart-legend-colorbox" [ngStyle]="{ 'background-color': nonDuesColor }"></div>
          <div class="chart-legend-value">{{ chartData.datasets[0].data[1] | currency }}</div>
          <div class="card-field-label">{{ 'profiles.view.revenue.non-dues' | translate }}</div>
        </div>
        <hr style="width: 100%; margin: 10px 0;" />
        <div class="annual-dues">
          <div class="chart-legend-value" style="margin-left: 0px !important; margin-bottom: 10px;">
            {{ 'profiles.view.revenue.recurring-billings' | translate | titlecase }}
          </div>
          <div class="mct-flex mct-col" *ngFor="let billing of billings; let i = index" >
            <div class="mct-flex mct-row" >
              <div class="mct-basis-50" >
                {{ billing.RevenueItem }}
              </div>
              <div class="mct-flex mct-justify-end mct-items-stretch mct-basis-50"  >
                {{ billing.AmountPerCycle | currency }}
              </div>
            </div>
            <div class="mct-flex mct-row" >
              <div class="mct-flex mct-row mct-basis-50"  >
                {{ 'common.month-names.' + billing.AnchorMonth.toString() | translate | titlecase }}&nbsp;
                <span class="card-field-label" style="margin-bottom: 0;">({{ billing.BillingCycle }} {{ billing.IsARB ? ('profiles.view.revenue.arb-tag' | translate | uppercase) : '' }})</span>
              </div>
            </div>
            <div style="margin-bottom: 27px;" *ngIf="i + 1 != billings.length"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="revenue-right">
    <h4>{{ 'profiles.view.revenue.aging-summary' | translate | titlecase }}</h4>
    <div *ngFor="let row of agingData; let i = index" class="aging-row">
      <div [ngClass]="i == agingData.length - 1 ? 'red' : 'card-field-label'">
        {{ row.Title }}
      </div>
      <div>
        <span [ngClass]="i == agingData.length - 1 ? 'red' : ''"
          ><strong>{{ row.AmountDue | currency }}</strong></span
        >
      </div>
    </div>
  </div>
</div>
